import { t, useLanguage } from "../i18n";
import { useEffect, useState } from 'react';
import { publicAPI } from '../services/api';
import { Star, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
export default function GoogleReview({
  orderId,
  onFinish,
  tipped = false
}) {
  useLanguage();
  const [establishment, setEstablishment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [opened, setOpened] = useState(false);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const {
          data: order
        } = await publicAPI.getOrder(orderId);
        const {
          data
        } = await publicAPI.getEstablishment(order.establishment_id);
        if (alive) setEstablishment(data);
      } catch {/* Finishing the visit remains possible without a review link. */} finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [orderId]);
  return <main className="min-h-[100dvh] flex items-center justify-center bg-[#F9FAFB] p-5">
    <section className="w-full max-w-md rounded-3xl bg-white p-6 text-center shadow-lg space-y-5">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-violet-100 text-violet-700"><Star aria-hidden="true" /></div>
      <p className="text-sm text-violet-700">{t("Merci de votre visite")} {tipped ? t(" et de votre générosité") : ''}</p>
      <h1 className="text-2xl font-bold">{establishment?.google_review_url ? t("Votre expérience compte") : t("À bientôt !")}</h1>
      <p className="text-slate-600">{establishment?.google_review_url ? t(establishment?.name ? "Partagez votre expérience chez {name} sur Google. Votre avis aide les prochains clients et notre équipe." : "Partagez votre expérience sur Google. Votre avis aide les prochains clients et notre équipe.", {
          name: establishment?.name
        }) : t("Nous espérons vous retrouver prochainement.")}</p>
      {loading ? <p role="status">{t("Chargement…")}</p> : establishment?.google_review_url && <>
        <a href={establishment.google_review_url} target="_blank" rel="noopener noreferrer" onClick={() => {
          setOpened(true);
          publicAPI.trackEvent({
            event_type: 'google_review_opened',
            order_id: orderId
          }).catch(() => {});
        }} className="flex min-h-12 items-center justify-center gap-2 rounded-full bg-[#7C3AED] px-5 py-3 font-semibold text-white">{t("Donner mon avis sur Google")}
          <ExternalLink className="h-4 w-4" aria-hidden="true" />
        </a>
        <p className="text-xs text-slate-500">{t("Google s’ouvre dans un nouvel onglet. Un compte Google peut être nécessaire.")}</p>
      </>}
      {opened && <p role="status" className="text-sm text-slate-600">{t("Vous pouvez revenir ici après avoir laissé votre avis.")}</p>}
      <Button variant="outline" className="w-full rounded-full" onClick={onFinish}>{opened || !establishment?.google_review_url ? t("Terminer ma visite") : t("Terminer sans laisser d’avis")}</Button>
    </section>
  </main>;
}
